import { API_ROUTES } from '@/constants/api-routes';
import queryKeys from '@/constants/queryKeys';
import { useAppMutation, useAppQuery } from '@/hooks/api';

export interface UserOnboardingData {
  editorOnboarded?: boolean;
  completedTours?: Record<string, number>;
  lastSeenReleaseVersionByModule?: Record<string, number>;
  firstLoginAt?: string;
  lastSeenAppVersion?: string;
  userPreferences?: {
    itemLevelEditWarning?: boolean;
    templateLevelEditWarning?: boolean;
  };
}

export const useGetUserOnboardingQuery = (enabled = true) => {
  return useAppQuery<UserOnboardingData>({
    routeName: API_ROUTES.GET_USER_ONBOARDING,
    queryKey: queryKeys.GET_USER_ONBOARDING,
    options: {
      enabled,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  });
};

export const useSaveUserOnboardingMutation = () => {
  return useAppMutation<void, { onboardingData: Partial<UserOnboardingData> }>({
    routeName: API_ROUTES.UPDATE_USER_ONBOARDING,
    mutationKey: [queryKeys.GET_USER_ONBOARDING, 'update'],
    method: 'POST',
    options: {},
  });
};
